import React from 'react';

const PersonalDocuments = (props) => (
  <svg
    width="20.002"
    height="19.602"
    viewBox="0 0 20.002 19.602"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <style>{`.a,.b{fill:#666;}.b{fill - rule:evenodd;}`}</style>
    </defs>
    <g transform="translate(-48 -2760.4)">
      <g transform="translate(48 2760)">
        <path
          className="a"
          d="M56.3,2772.028a1.973,1.973,0,0,1,.161-.771.331.331,0,0,0-.017-.3.407.407,0,0,0-.262-.2,7.1,7.1,0,0,0-1.885-.26,6.544,6.544,0,0,0-6.274,4.095.343.343,0,0,0,.068.336.451.451,0,0,0,.35.153h7.423a.41.41,0,0,0,.437-.382Z"
          transform="translate(-48 -2761.333)"
        />
        <path
          className="a"
          d="M54.21,2767.6a3.8,3.8,0,1,0-3.96-3.8A3.884,3.884,0,0,0,54.21,2767.6Z"
          transform="translate(-47.975 -2759.6)"
        />
        <path
          className="b"
          d="M60.667,2771h7.5a1.669,1.669,0,0,1,1.667,1.667v7.5a1.669,1.669,0,0,1-1.667,1.667h-7.5A1.669,1.669,0,0,1,59,2780.168v-7.5A1.669,1.669,0,0,1,60.667,2771Zm.208,1.667a.207.207,0,0,0-.208.208v7.084a.207.207,0,0,0,.208.208h7.084a.232.232,0,0,0,.148-.059.211.211,0,0,0,.061-.15v-7.084a.207.207,0,0,0-.208-.208Z"
          transform="translate(-49.833 -2761.832)"
        />
        <path
          className="a"
          d="M67.084,2775H63.125a.625.625,0,1,0,0,1.25h3.959a.625.625,0,1,0,0-1.25Z"
          transform="translate(-50.416 -2762.499)"
        />
        <path
          className="a"
          d="M65,2779.25a.625.625,0,1,0,0-1.25H63.125a.625.625,0,1,0,0,1.25Z"
          transform="translate(-50.416 -2762.999)"
        />
      </g>
    </g>
  </svg>
);

export default PersonalDocuments;
